class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // open & update cart drawer without page reload
    document.addEventListener('my-cart:refresh-and-open', async () => {
      try {
        const response = await fetch(
          `${window.Shopify.routes.root}?sections=cart-drawer`
        );

        if (!response.ok) {
          throw new Error('Could not fetch cart drawer');
        }

        const sections = await response.json();
        const drawerHTML = sections['cart-drawer'];

        if (!drawerHTML) {
          throw new Error('Cart drawer section is missing');
        }

        const parsedHTML = new DOMParser().parseFromString(
          drawerHTML,
          'text/html'
        );

        const currentDrawer = this.querySelector('.drawer__inner');
        const newDrawer =
          parsedHTML.querySelector('#CartDrawer .drawer__inner') ||
          parsedHTML.querySelector('cart-drawer .drawer__inner') ||
          parsedHTML.querySelector('.drawer__inner');

        if (!currentDrawer || !newDrawer) {
          throw new Error('Could not find the drawer inner content');
        }

        currentDrawer.innerHTML = newDrawer.innerHTML;

        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`
        );

        if (!cartResponse.ok) {
          throw new Error('Could not fetch cart data');
        }

        const cart = await cartResponse.json();
        this.classList.toggle('is-empty', cart.item_count === 0);
        currentDrawer.classList.toggle('is-empty', cart.item_count === 0);

        const cartIcon = document.querySelector('#cart-icon-bubble');

        if (cartIcon) {
          let count = cartIcon.querySelector('.ss-dawn-cartcount');

          if (cart.item_count > 0) {
            if (!count) {
              count = document.createElement('span');
              count.className = 'ss-dawn-cartcount';
              cartIcon.appendChild(count);
            }

            count.textContent = cart.item_count;
            count.setAttribute('aria-label', String(cart.item_count));
          } else if (count) {
            count.remove();
          }
        }

        this.open();
      } catch (error) {
        console.error('Cart drawer refresh failed:', error);
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
